<script>
    import { _ } from "svelte-i18n";
    import { LANGUAGES } from "../common/lang";
    import Select from "./Select.svelte";

    export let value;
    export let none = false;
    let clazz = "";
    export { clazz as class };
</script>

<Select
    options={none ? [{ value: '', text: $_('NoLanguage') }, ...LANGUAGES] : LANGUAGES}
    bind:value
    let:option
    let:selected
    class={clazz} />
